const ERRORCLASS = 'error';

function wordRegexp(words) {
    return new RegExp(`^((${words.join(')|(')}))\\b`, 'i');
}

const singleOperators = new RegExp('^[=\\+\\-\\*/%&\\\\|\\^~<>!]');
const singleDelimiters = new RegExp('^[\\(\\)\\[\\]\\{\\}@,:`=;\\.]');
const doubleOperators = new RegExp(
    '^((==)|(<>)|(<=)|(>=)|(<>)|(<<)|(>>)|(//)|(\\*\\*))',
);
const doubleDelimiters = new RegExp(
    '^((\\+=)|(\\-=)|(\\*=)|(%=)|(/=)|(&=)|(\\|=)|(\\^=))',
);
const tripleDelimiters = new RegExp('^((//=)|(>>=)|(<<=)|(\\*\\*=))');
const identifiers = new RegExp('^[_A-Za-z][_A-Za-z0-9]*');
const objects = [
    'adc',
    'beep',
    'bt',
    'button',
    'fd',
    'io',
    'kp',
    'lcd',
    'net',
    'pat',
    'ppp',
    'pppoe',
    'romfile',
    'rtc',
    'ser',
    'sock',
    'ssi',
    'stor',
    'sys',
    'wln',
];

const openingKeywords = [
    'class',
    'module',
    'sub',
    'enum',
    'select',
    'while',
    'if',
    'function',
    'get',
    'set',
    'property',
    'try',
    'structure',
    'synclock',
    'using',
    'with',
];
const middleKeywords = ['else', 'elseif', 'case', 'catch', 'finally'];
const endKeywords = ['next', 'loop'];

const operatorKeywords = [
    'and',
    'andalso',
    'or',
    'orelse',
    'xor',
    'in',
    'not',
    'is',
    'isnot',
    'like',
];
const booleanKeywords = ['true', 'false', 'nothing'];
const wordOperators = wordRegexp(operatorKeywords);

const commonKeywords = [
    'And',
    'AndAlso',
    'As',
    'Boolean',
    'ByRef',
    'Byte',
    'ByVal',
    'Case',
    'CBool',
    'CByte',
    'CChar',
    'CDate',
    'CDbl',
    'CDec',
    'CInt',
    'CLng',
    'CObj',
    'CSByte',
    'CShort',
    'CSng',
    'CStr',
    'CType',
    'CUInt',
    'CULng',
    'CUShort',
    'Char',
    'Const',
    'Continue',
    'Decimal',
    'Declare',
    'Default',
    'Dim',
    'Do',
    'Double',
    'Each',
    'Else',
    'ElseIf',
    'End',
    'EndIf',
    'Enum',
    'Erase',
    'Error',
    'Event',
    'Exit',
    'False',
    'Finally',
    'For',
    'Function',
    'Get',
    'GetType',
    'GoSub',
    'GoTo',
    'Handles',
    'If',
    'Implements',
    'Imports',
    'In',
    'Inherits',
    'Integer',
    'Interface',
    'Is',
    'IsFalse',
    'IsNot',
    'IsTrue',
    'Let',
    'Lib',
    'Like',
    'Long',
    'Loop',
    'Me',
    'Mod',
    'Module',
    'MustInherit',
    'MustOverride',
    'My',
    'MyBase',
    'MyClass',
    'Namespace',
    'Narrowing',
    'New',
    'Next',
    'Not',
    'Nothing',
    'NotInheritable',
    'NotOverridable',
    'Object',
    'Of',
    'On',
    'Operator',
    'Option',
    'Optional',
    'Or',
    'OrElse',
    'Out',
    'Overloads',
    'Overridable',
    'Overrides',
    'ParamArray',
    'Partial',
    'Private',
    'Property',
    'Protected',
    'Public',
    'RaiseEvent',
    'ReadOnly',
    'ReDim',
    'RemoveHandler',
    'Resume',
    'Return',
    'SByte',
    'Select',
    'Set',
    'Shadows',
    'Shared',
    'Short',
    'Single',
    'Static',
    'Step',
    'Stop',
    'String',
    'Structure',
    'Sub',
    'Then',
    'Throw',
    'To',
    'True',
    'TryCast',
    'TypeOf',
    'UInteger',
    'ULong',
    'UShort',
    'Until',
    'When',
    'While',
    'Widening',
    'With',
    'WithEvents',
    'WriteOnly',
    'Xor',
    'define',
];

const punctuation = /[{}().,:?]/;

const commontypes = [
    'char',
    'byte',
    'short',
    'integer',
    'word',
    'long',
    'dword',
    'real',
    'float',
    'string',
    'boolean',
];

const macroKeywords = ['#ifdef', '#ifndef', '#if', '#else', '#endif'];

const includeKeywords = ['include', 'includepp'];

const includes = wordRegexp(includeKeywords);
const macros = wordRegexp(macroKeywords);
const keywords = wordRegexp(commonKeywords);
const types = wordRegexp(commontypes);
const stringPrefixes = '"';
const booleans = wordRegexp(booleanKeywords);

const opening = wordRegexp(openingKeywords);
const middle = wordRegexp(middleKeywords);
const closing = wordRegexp(endKeywords);
const doubleClosing = wordRegexp(['end']);
const doOpening = wordRegexp(['do']);

const indentInfo = null;

function indent(_stream, state) {
    state.currentIndent++;
}

function dedent(_stream, state) {
    state.currentIndent--;
}
// tokenizers
function tokenBase(stream, state) {
    if (stream.eatSpace()) {
        return null;
    }

    const ch = stream.peek();

    // Handle Comments
    if (ch === "'") {
        stream.skipToEnd();
        return 'comment';
    }

    // Handle Number Literals
    if (stream.match(/^((&H)|(&O))?[0-9.a-f]/i, false)) {
        let floatLiteral = false;
        // Floats
        if (stream.match(/^\d*\.\d+F?/i)) {
            floatLiteral = true;
        } else if (stream.match(/^\d+\.\d*F?/)) {
            floatLiteral = true;
        } else if (stream.match(/^\.\d+F?/)) {
            floatLiteral = true;
        }

        if (floatLiteral) {
            // Float literals may be "imaginary"
            stream.eat(/J/i);
            return 'number';
        }
        // Integers
        let intLiteral = false;
        // Hex
        if (stream.match(/^&H[0-9a-f]+/i)) {
            intLiteral = true;
        }
        // Octal
        else if (stream.match(/^&O[0-7]+/i)) {
            intLiteral = true;
        }
        // Decimal
        else if (stream.match(/^[1-9]\d*F?/)) {
            // Decimal literals may be "imaginary"
            stream.eat(/J/i);
            // TODO - Can you have imaginary longs?
            intLiteral = true;
        }
        // Zero by itself with no other piece of number.
        else if (stream.match(/^0(?![\dx])/i)) {
            intLiteral = true;
        }
        if (intLiteral) {
            // Integer literals may be "long"
            stream.eat(/L/i);
            return 'number';
        }
    }

    // Handle Strings
    if (stream.match(stringPrefixes)) {
        state.tokenize = tokenStringFactory(stream.current());
        return state.tokenize(stream, state);
    }

    if (stream.match(booleans)) {
        return 'bool';
    }

    if (stream.match(includes)) {
        return 'moduleKeyword';
    }

    if (stream.match(macros)) {
        stream.skipToEnd();
        return 'comment';
    }
    if (stream.match(punctuation)) {
        return 'punctuation';
    }

    // Handle operators and Delimiters
    if (stream.match(tripleDelimiters) || stream.match(doubleDelimiters)) {
        return null;
    }
    if (stream.match(doubleOperators) || stream.match(singleOperators)) {
        return 'operator';
    }
    if (stream.match(singleDelimiters)) {
        return null;
    }
    if (stream.match(doOpening)) {
        indent(stream, state);
        state.doInCurrentLine = true;
        return 'keyword';
    }
    if (stream.match(opening)) {
        if (!state.doInCurrentLine) indent(stream, state);
        else state.doInCurrentLine = false;
        return 'keyword';
    }
    if (stream.match(middle)) {
        return 'keyword';
    }

    if (stream.match(doubleClosing)) {
        dedent(stream, state);
        dedent(stream, state);
        return 'keyword';
    }
    if (stream.match(closing)) {
        dedent(stream, state);
        return 'keyword';
    }

    if (stream.match(types)) {
        return 'keyword';
    }

    if (stream.match(keywords)) {
        return 'keyword';
    }

    if (stream.match(wordRegexp(objects))) {
        return 'className';
    }

    if (stream.match(identifiers)) {
        return 'variable';
    }

    // Handle non-detected items
    stream.next();
    return ERRORCLASS;
}

function tokenStringFactory(delimiter) {
    const singleline = delimiter.length === 1;
    const OUTCLASS = 'string';

    return (stream, state) => {
        while (!stream.eol()) {
            stream.eatWhile(/[^'"]/);
            if (stream.match(delimiter)) {
                state.tokenize = tokenBase;
                return OUTCLASS;
            }
            stream.eat(/['"]/);
        }
        if (singleline) {
            state.tokenize = tokenBase;
        }
        return OUTCLASS;
    };
}

function tokenLexer(stream, state) {
    let style = state.tokenize(stream, state);
    const current = stream.current();

    // Handle '.' connected identifiers
    if (current === '.') {
        style = state.tokenize(stream, state);
        if (style === 'variable') {
            return 'variable';
        }
        return ERRORCLASS;
    }

    let delimiter_index = '[({'.indexOf(current);
    if (delimiter_index !== -1) {
        indent(stream, state);
    }
    if (indentInfo === 'dedent') {
        if (dedent(stream, state)) {
            return ERRORCLASS;
        }
    }
    delimiter_index = '])}'.indexOf(current);
    if (delimiter_index !== -1) {
        if (dedent(stream, state)) {
            return ERRORCLASS;
        }
    }

    return style;
}

// eslint-disable-next-line import/prefer-default-export
export const tibbobasic = {
    name: 'tibbobasic',

    startState() {
        return {
            tokenize: tokenBase,
            lastToken: null,
            currentIndent: 0,
            nextLineIndent: 0,
            doInCurrentLine: false,
        };
    },

    token(stream, state) {
        if (stream.sol()) {
            state.currentIndent += state.nextLineIndent;
            state.nextLineIndent = 0;
            state.doInCurrentLine = 0;
        }
        const style = tokenLexer(stream, state);

        state.lastToken = { style, content: stream.current() };

        return style;
    },

    indent(state, textAfter, cx) {
        const trueText = textAfter.replace(/^\s+|\s+$/g, '');
        if (
            trueText.match(closing)
      || trueText.match(doubleClosing)
      || trueText.match(middle)
        ) return cx.unit * (state.currentIndent - 1);
        if (state.currentIndent < 0) return 0;
        return state.currentIndent * cx.unit;
    },

    languageData: {
        closeBrackets: { brackets: ['(', '[', '{', '"'] },
        commentTokens: { line: "'" },
        autocomplete: openingKeywords
            .concat(middleKeywords)
            .concat(endKeywords)
            .concat(operatorKeywords)
            .concat(commonKeywords)
            .concat(commontypes),
    },
};
